import styled from '@emotion/styled';
import { Text } from '@pairy/pds-react';
import { theme, animation } from '@pairy/styles';
import { motion } from 'framer-motion';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const AnimationWrapper = styled(motion.div)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const CtaAnimationButton = styled(motion.button)`
  z-index: ${VIEWER_Z_INDEX.ctaButton};
  width: fit-content;
  min-width: 50px;
  padding: 16px;
  border: 1px solid ${theme.colors.zinc_400};
  animation: ${animation.pulse('79, 88, 96', 1)} 2.5s infinite;
  background-color: ${theme.colors.zinc_700};
  border-radius: 8px;
  box-shadow: ${theme.elevation.sm};
  pointer-events: auto;
`;

export const CtaButtonDot = styled.div`
  width: 16px;
  height: 16px;
  padding: 16px;
  border: 1px solid ${theme.colors.zinc_400};
  background-color: ${theme.colors.zinc_700};
  border-radius: 8px;
  pointer-events: auto;
`;

export const CtaButtonText = motion(Text);
